import ReactSVG from 'react-svg'
import {css} from 'glamor';
import * as React from 'react';
import * as globals from '../Globals/Globals'
import interact from 'interactjs'
import Draggable from 'react-draggable';
import * as papa from 'papaparse'
import { readFileSync } from 'fs';
import * as ReactDOM from 'react-dom';
import { DndProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend';
import '../../css/ScatterPlot.css'
import { thresholdScott } from 'd3-array';
import GraphBorder from '../GraphComponents/Canvas/GraphBorder';

import TouchBackend from 'react-dnd-touch-backend'
interface LayoutCanvasProps{
    id:string
    idX:string,
    idY:string,
    idZ:string,
    yaxis:string,
    xaxis:string,
    width:number,
    height:number,
    datatype:string
}

interface LayoutCanvasStates{
   expectation?: string
  }

class LayoutCanvas extends React.Component<LayoutCanvasProps,LayoutCanvasStates>{
   
    constructor(props:any){
        super(props);
        this.state ={
            expectation: "",
        }
    }
 
    
    public render(){
       
        return(
            <DndProvider backend={HTML5Backend}>
                <GraphBorder id={this.props.id} idX={this.props.idX} idY={this.props.idY} idZ={this.props.idZ} xaxis={this.props.xaxis} yaxis={this.props.yaxis} height={this.props.height} width={this.props.width} yaxisStatus={"Off"} xaxisStatus={"On"} datatype={this.props.datatype} ></GraphBorder>
            </DndProvider>
        )
    }
}

export default LayoutCanvas;

{/* <DndProvider backend={HTML5Backend}>

                <rect x={0.034*this.props.width} y={0.022*this.props.height} className="st0" width={0.15*this.props.width} height={0.12*this.props.height}/>
              

<svg version="1.1" id="Layer_1" x="0px" y="0px"
className="canvas" width={this.props.width} height={this.props.height}>
<rect x="102.7" y="96" transform="matrix(9.640157e-07 -1 1 9.640157e-07 -56.7061 292.0896)" className="st0" width="30" height="156.8"/>
<text id="x-axis" transform="matrix(1 0 0 1 43.1897 177.9507)" className="st2 st3">{this.props.xaxis}</text>

<rect x="6.8" y="4.4" className="st0" width="30" height="24"/>
<YAxisTarget xaxis={this.props.xaxis} yaxis={this.props.yaxis} height={this.props.height} width={this.props.width} yaxisStatus={"Off"}></YAxisTarget>
</svg>
</DndProvider> */}